module.exports = __webpack_public_path__ + "static/media/1000223.c5533e6e.png";